import React from "react";
import { Link } from "react-router-dom";
import Hero from "../components/Hero";
import Banner from "../components/Banner";
import Services from "../components/Services";
import FeaturedRooms from "../components/FeaturedRooms";
const home = () => {
  return (
    <>
      <Hero>
        <Banner
          title="Find, Hire, Maintain"
          subtitle="The talanta API And HR tools helps to make your Team's Talent Acquisition And Talent Management Easy"
        >
          <Link to="/register" className="btn-primary">
            get started for free
          </Link>
        </Banner>
      </Hero>
      <Services />
      <FeaturedRooms />
    </>
  );
};

export default home;
